<template>
    <div class="container pt-5" style="pading-top:300px">
        <div class="text-center">
            <h2 class="pt-5">O nama</h2>
            <hr class="w-50 mx-auto mb-4">
        </div>
        <section class="container my-5">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <p>
                        <strong>Program Ishrane</strong> je lokalizovana verzija originalne aplikacije
                        <a href="https://www.programprehrane.com" target="_blank" rel="noopener noreferrer">Program
                            Prehrane</a>,
                        razvijene u Hrvatskoj od strane tima stručnjaka za nutricionizam i digitalna rešenja.
                    </p>
                    <p>
                        Naša verzija je prevedena na srpski jezik (latinično i ćirilično pismo).
                    </p>
                    <p>
                        Cilj aplikacije <strong>Program Ishrane</strong> je da omogući jednostavno, stručno i
                        personalizovano vođenje ishrane,
                        kako za pojedince, tako i za nutricioniste i dijetetičare koji rade sa klijentima.
                    </p>
                    <p>Kao zvanični partner i distributer za Srbiju, obezbeđujemo:</p>
                    <ul>
                        <li>lokalnu korisničku podršku,</li>
                        <li>redovne prevode i prilagođavanja,</li>
                        <li>kao i povezivanje sa stručnjacima iz oblasti ishrane u zemlji.</li>
                    </ul>
                    <p>
                        Radimo transparentno, u dogovoru s autorima originalne aplikacije, i posvećeni smo pružanju
                        vrhunskog alata
                        koji pomaže korisnicima da postignu i održe zdrav odnos prema hrani.
                    </p>
                    <p>
                        Za sve dodatne informacije ili podršku, slobodno nas kontaktirajte putem
                        <a href="mailto:office@symappsys.com">office@symappsys.com</a>.
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: 'Program Ishrane',
            titleTemplate: '%s | ' + 'O nama',
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/pages/aboutus.vue